import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { API_BASE_URL } from "../../../../../utils/useFetch";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";

const UpdateAddressModal = ({ showModal, previousAddress }: any) => {
  const userData = useSelector((state: RootState) => state.user.userInfo);

  const [address, setAddress] = useState(previousAddress.address);

  const [isSendingData, setIsSendingData] = useState(false);

  const addAdrsFetch = async () => {
    const _formData = new FormData();
    _formData.append("address_id", previousAddress.id);
    _formData.append("address", address);
    _formData.append("code", userData.code);
    _formData.append("mobile", userData.mobile);
    setIsSendingData(true);
    const response = await fetch(API_BASE_URL + "newupdateaddress", {
      method: "POST",
      body: _formData,
    });
    return response.json();
  };

  const validateForm = () => {
    if (address.length < 10) {
      toast.error("لطفا آدرس خود را کامل بنویسید");
      return;
    }
    return true;
  };

  const onFormSubmit = (e: any) => {
    e.preventDefault();
    if (validateForm()) {
      addAdrsFetch().then((response) => {
        setIsSendingData(false);
        if (response) {
          toast.success("آدرس با موفقیت ویرایش شد");
          showModal();
        } else {
          toast.error("Error XyffycpP");
        }
      });
    }
  };
  return (
    <div className='modal'>
      <div
        className='modal-background'
        onClick={() => showModal()}
      ></div>
      <div className='modal-content'>
        <div className='box'>
          <div className='flex border-b'>
            <div className='flex-1 font-bold p-4'> افزودن آدرس</div>
            <div>
              <button
                onClick={() => showModal()}
                className='p-4'
                aria-label='close'
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>

          <div className='p-2'>
            <form
              className={`space-y-4`}
              action='#'
              onSubmit={onFormSubmit}
            >
              <div>
                <label
                  htmlFor='region'
                  className='block mb-2 text-sm font-medium'
                >
                  منطقه
                </label>
                <input
                  type='text'
                  name='region'
                  value={previousAddress.region}
                  disabled
                  className='bg-gray-50 border border-gray-300  text-sm rounded outline-rose-700 block w-full p-2'
                />
              </div>
              <div>
                <label
                  htmlFor='address'
                  className='block mb-2 text-sm font-medium'
                >
                  آدرس کامل
                </label>
                <textarea
                  name='address'
                  onChange={(e) => setAddress(e.target.value)}
                  defaultValue={address}
                  className='bg-gray-50 border border-gray-300  text-sm rounded outline-rose-700 block w-full p-2'
                />
              </div>

              <div className=''>
                <button
                  type='submit'
                  disabled={isSendingData}
                  className='flex-1 w-full cursor-pointer text-white bg-rose-900 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                >
                  {isSendingData ? (
                    <FontAwesomeIcon
                      icon={faCircleNotch}
                      className='rotate-animation'
                    />
                  ) : (
                    "ویرایش"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateAddressModal;
